import { Box, Typography, Divider } from '@mui/material';

import { fCurrency } from '../../utils/formatNumber';
import { useRole } from '../../hooks/useRole';
import { useGetRequestPaymentSummaryQuery } from '../../slices/apis/requestApi';

interface TotalSummaryProps {
	requestId?: string;
	total?: number;
	subtotal?: number;
	gst?: number;
	discount?: number;
	discountLabel?: string;
}

export const TotalSummary = ({
	requestId,
	total: totalProp,
	subtotal: subtotalProp,
	gst: gstProp,
	discountLabel = 'Discount',
	discount: discountProp = 0,
}: TotalSummaryProps) => {
	const { isSupplier } = useRole();
	const { data: paymentSummary } = useGetRequestPaymentSummaryQuery(requestId ?? '', {
		skip: !requestId || isSupplier,
	});

	const total = requestId ? paymentSummary?.paidAmount : totalProp;
	const subtotal = requestId ? paymentSummary?.totalWithoutGst : subtotalProp;
	const gst = requestId ? paymentSummary?.paidGstAmount : gstProp;
	const discount = requestId ? (paymentSummary?.discountedAmount ?? 0) : discountProp;

	if (total === undefined || subtotal === undefined || gst === undefined) {
		return null;
	}

	return (
		<>
			<Divider sx={{ mb: 2 }} />

			<Box display="flex" justifyContent="space-between" mb={1}>
				<Typography>Items Total:</Typography>
				<Typography>{fCurrency(subtotal)}</Typography>
			</Box>
			{discount !== 0 && (
				<Box display="flex" justifyContent="space-between" mb={1}>
					<Typography>{discountLabel}:</Typography>
					<Typography>{fCurrency(-discount)}</Typography>
				</Box>
			)}
			<Box display="flex" justifyContent="space-between" mb={1}>
				<Typography>GST(10%):</Typography>
				<Typography>{fCurrency(gst)}</Typography>
			</Box>
			<Divider sx={{ my: 2 }} />
			<Box display="flex" justifyContent="space-between">
				<Typography fontWeight="bold" variant="h5">
					Total
				</Typography>
				<Typography fontWeight="bold" variant="h5">
					{fCurrency(total)}
				</Typography>
			</Box>
		</>
	);
};
